var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('div',[_vm._v("关于寒假训练营的事情请识别下方二维码进行咨询。")]),_c('img',{attrs:{"src":require("../../common/img/contact.jpg")}})])}]

export { render, staticRenderFns }